'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	generalWrapper: {
		width: '100%',
		maxWidth: '560px',
		borderRadius: '5px',
		backgroundColor: 'white',
		border: 'solid 1px #9da3a6',
		boxSizing: 'border-box',
		fontSize: '15px',
		lineHeight: '1.4'
	},
	iconTopperWrapper: {
		position: 'relative',
		width: '50px',
		maxWidth: '50px',
		height: '50px',
		maxHeight: '50px',
		paddingBottom: '5px',
		margin: '-25px auto 0',
		display: 'table',
		border: '1px solid #9d9d9d',
		borderRadius: '50%',
		color: '#9d9d9d',
		textAlign: 'center',
		background: '#ffffff'
	},
	PrimaryFontFamily: {
		fontFamily: '"HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif',
		fontWeight: 'normal',
		WebkitFontSmoothing: 'antialiased',
		MozFontSmoothing: 'antialiased',
		msFontSmoothing: 'antialiased',
		OFontSmoothing: 'antialiased',
		fontSmoothing: 'antialiased'
	},

	// good for use with <H2>s

	ViewHeaderText: {
		fontFamily: '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, sans-serif',
		fontWeight: 'normal',
		fontSize: '1.8em',
		margin: 0,
		padding: 0
	}
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/styles.js
// module id = 363
// module chunks = 6